import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import MainLayout from '../../components/Layout/MainLayout';

export default function NotFound() {
  return (
    <MainLayout showSidebar={false}>
      <div style={{ padding: '80px 0', textAlign: 'center' }}>
        <h1 style={{ fontSize: 72, color: '#004632', marginBottom: 16 }}>404</h1>
        <h2>Página no encontrada</h2>
        <p style={{ color: '#999', margin: '16px 0 32px' }}>
          Lo sentimos, la página que buscas no existe.
        </p>
        <Link to="/">
          <Button type="primary" size="large">
            Volver al inicio
          </Button>
        </Link>
      </div>
    </MainLayout>
  );
}
